<template>
    <div class="carousel-container">
        <v-row align-items="center" justify="space-evenly" class="header">
            <v-col style="display: flex; flex-direction: column; align-items: start;">
                <v-btn @click="$emit('close-content')" variant="text" color="inherit"><img
                        src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/642712b9-7c61-4e25-87b0-5b7aefc49d67.svg"
                        alt=""></v-btn>
                <p class="submenu-title">{{ item.title }}</p>
            </v-col>
        </v-row>

        <div class="carousel-content">
            <Carousel :items-to-show="1">
                <Slide v-for="slide in item.content" :key="slide">
                    <img style="width:80%" :src="slide" alt="">
                </Slide>

                <template #addons>
                    <Navigation />
                    <pagination />
                </template>
            </Carousel>
        </div>
    </div>
</template>

<script setup>
import { defineEmits, defineProps } from 'vue';
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel"

defineEmits(["close-content"])
const props = defineProps(["item"])

console.log("Item aqui: ", props.item)

</script>

<style scoped>
.carousel-container {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 2;
    background: white;
}

.header {
    height: 25%;
    background-color: #BC4AFF;
}

.submenu-title {
    color: white;
    font-size: 20px;
    text-align: start;
    margin-left: 10%;
    margin-top: 7%;
}

.carousel-content {
    margin-top: 10%;
}
</style>